
export class Create {
    constructor(public message: string) { }
}
